import {
  GET_REPAS_HISTORY,
  GET_REPAS_HISTORY_FAILURE,
  GET_REPAS_HISTORY_REQUEST,
} from "../types/repas";

export const getRepasHistory = ({ token, pageNumber }) => {
  return (dispatch) => {
    dispatch({ type: GET_REPAS_HISTORY_REQUEST });
    fetch(
      `https://shopngo.herokuapp.com/api/meal/history?pageNumber=${pageNumber}`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
      }
    )
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        if (res.errors) {
          dispatch({
            type: GET_REPAS_HISTORY_FAILURE,
            value: res.errors.status,
          });
        } else {
          dispatch({ type: GET_REPAS_HISTORY, value: res });
        }
      })
      .catch((error) => console.log(error));
  };
};
